module.exports = __webpack_public_path__ + "static/media/logo-regenera-negativo.a2328361.svg";